import { Injectable, signal } from '@angular/core';

export interface AppError {
  type: 'network' | 'service-unavailable' | 'server-error' | 'unknown';
  message: string;
  timestamp: Date;
  retryable?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorStateService {
  private error = signal<AppError | null>(null);

  // Expose as readonly
  readonly currentError = this.error.asReadonly();

  setError(error: AppError): void {
    this.error.set(error);
  }

  clearError(): void {
    this.error.set(null);
  }

  hasError(): boolean {
    return this.error() !== null;
  }
}
